import React from 'react';
import SEO from '../components/SEO';
import { SEO_METADATA } from '../config/seoMetadata';
import Header from '../components/Header';
import HeroSlider from '../components/HeroSlider';
import NextConcert from '../components/NextConcert';
import Programs from '../components/Programs';
import Impact from '../components/Impact';
import Gallery from '../components/Gallery';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';

const HomePage = () => {
  const seo = SEO_METADATA.home;

  return (
    <>
      <SEO
        title={seo.title}
        description={seo.metaDescription}
        keywords={seo.keywords}
        canonical="/"
        additionalMetaTags={[
          { property: 'og:title', content: seo.openGraph.title },
          { property: 'og:description', content: seo.openGraph.description }
        ]}
      />
      <Header />
      <main className="mx-8 md:mx-12">
        <HeroSlider />
        <NextConcert />
        <Programs />
        <Impact />
        <Gallery />
        <Newsletter />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;